import { useBreakpointsContext } from '@air/provider-media-query';

import { usePendingAnimatedUploadStepValue } from '~/components/v2/store/features/onboarding/useOnboardingPreferencesStore';

type UseAnimatedOnboardingUploadVisibilityResult = {
  showAnimatedWorkspace: boolean;
  showPendingAnimatedUploadStep: boolean;
};

export const useAnimatedOnboardingUploadVisibility = (
  workspaceId: string | undefined,
): UseAnimatedOnboardingUploadVisibilityResult => {
  const { isAboveMediumScreen } = useBreakpointsContext();
  const pendingAnimatedUploadStep = usePendingAnimatedUploadStepValue();

  const showAnimatedWorkspace = isAboveMediumScreen;
  const showPendingAnimatedUploadStep =
    !!workspaceId && Boolean(showAnimatedWorkspace && pendingAnimatedUploadStep?.workspaceId === workspaceId);

  return { showAnimatedWorkspace, showPendingAnimatedUploadStep };
};
